import React from "react";
import PropTypes from "prop-types";
import { Image } from "@learningblocks/shared-components";
import { LabTableIcon as TableImage } from "../../Icons";

export function LabTable(props) {
  return <Image className={props.className} src={TableImage} alt="labTable" />;
}

LabTable.propTypes = {
  /**
   * ClassName for component
   */
  className: PropTypes.string,
};

LabTable.defaultProps = {};
